import { Component, OnInit } from '@angular/core';
import { TravelService } from 'src/app/services/travel.service';
import { Travel } from 'src/app/models/travel';
import { NgbDateAdapter, NgbModal, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { Product } from 'src/app/models/product';
import { environment } from "src/environments/environment";
import { RouterLink, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ReportService } from 'src/app/services/report.service';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';

interface customerTmp {
  id:number,
  name:string,
}

@Component({
  selector: 'app-travel',
  templateUrl: './travel-list.component.html',
  styleUrls: ['./travel-list.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class TravelListComponent implements OnInit {
  travels = [];
  travelsAll = [];
  loading:boolean = false;
  date1:Date = new Date();
  date2:Date = new Date();
  travel:any;
  customers:customerTmp[] = [];
  selectedCustomers:customerTmp[] = [];
  customer:customerTmp;
  plants:Customer[] = [];
  plant:Customer = null;
  products:Product[] = [];
  expand:boolean = false;
  productsList:Product[] = [];
  productTmp:Product = null;
  selectedProducts:Product[] = [];

  updown:number = 1;
  sorted:string = '';
  status:string = '';
  contracted:boolean = false;
  description = null;
  
  canEdit:boolean = false;

  ton:number = 0;
  tonReal:number = 0;

  constructor(private travelServ:TravelService, private modalService: NgbModal, private utl:UtilitiesService, private custServ:CustomerService, private productServ:ProductService, private router:Router, private authServ:AuthService, private toastr: ToastrManager, private reportServ:ReportService, private logisticEv:LogisticEventsService) { }

  ngOnInit() {
    this.loading = true;
    this.custServ.getCustomers('Intercompañia').then(customers => {
      this.plants = customers;
    });
    this.productServ.getProducts().then(products => {
      this.products = products;
      this.loading = false;
    });
    this.canEdit = this.authServ.can('update-order');
  }

  download(type) {
    let urlPart2 = '';

    if (this.contracted) {
      urlPart2 += '&contracted=true';
    }
    if (this.plant) {
      urlPart2 += '&sourceCustomer=' + this.plant;
    }
    if (this.selectedCustomers.length) {
      urlPart2 += '&customers=' + this.selectedCustomers.map(sc => sc.id).toString();
    }
    if (this.selectedProducts.length) {
      urlPart2 += '&products=' + this.selectedProducts.map(sp => sp.id).toString();
    }

    window.open(environment.baseUrl + '/' + type + '/travels?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + urlPart2, '_blank')
  }

  search() {
    this.loading = true;
    this.reportServ.travelsReport(this.date1, this.date2).then(travels => {
      this.travels = travels;
      this.travelsAll = this.travels;
      this.customer = null;
      this.contracted = false;
      this.plant = null;
      this.selectedCustomers = [];
      this.selectedCustomers = [];

      this.allCustomers();
      this.getProductsList();

      this.calcTons();
      this.loading = false;
    });
  }

  sort(param) {
    this.travels = this.travels.sort(this.utl.dynamicSort((this.updown == 1 ? '' : '-') + param));
    this.updown = this.updown*-1;
    this.sorted = param;
  }

  select(modal, travel) {
    this.travel = travel;
    this.modalService.open(modal, { size: 'lg' });
  }

  addFilter() {
    if (this.customer) {
      this.selectedCustomers.push(this.customer);
    } else {
      this.selectedCustomers = [];
    }
    this.filterAll();
  }

  addProductFilter(){
    if(this.productTmp && this.selectedProducts.indexOf(this.productTmp) == -1){
      this.selectedProducts.push(this.productTmp);
      this.filterAll();
    }    
  }
  removeProductOfFilter(filter: Product){
    this.selectedProducts.splice(this.selectedProducts.indexOf(filter),1);
    this.filterAll();
  }

  removeFilter(filter:customerTmp) {
    this.selectedCustomers = this.selectedCustomers.filter(sc => sc.id != filter.id);
    this.filterAll();
  }

  allCustomers() {
    this.customers = [];
    this.travelsAll.forEach(tr => {
      if (!this.customers.find(c => c.id == tr.target_customer_id)) {
        this.customers.push({
          name: tr.target_customer,
          id: tr.target_customer_id,
        });
      }
    });
  }

  getProductsList(){
    this.productsList = [];
    this.travelsAll.forEach(pl => {
      if(!this.productsList.find(p => p.id == pl.product_id)) {        
        this.productsList.push({        
          id : pl.product_id,
          name : pl.product_name,
          division : pl.division,
          active : true
        });
      };
    });
  }

  filterAll() {
    this.travels = this.utl.filterBy(this.utl.filterBy(this.utl.filterBy(this.utl.filterBy(this.travelsAll, 'target_customer', this.selectedCustomers.map( sc => sc.name)), 'source_customer', this.plant ? [this.plant.name] : []), 'contracted', this.contracted ? [this.contracted] : []), 'product_id', this.selectedProducts.length ? this.selectedProducts.map(sp => sp.id) : []);
    this.calcTons();
  }

  calcTons() {
    this.ton = 0;
    this.tonReal = 0;
    for(let i = 0; i < this.travels.length; i++) {
      if (this.travels[i].status != 'Cancelado') {
        this.ton += Number(this.travels[i].ton);
        this.tonReal += Number(this.travels[i].ton_real);
      }
    }
  }

  removeTravel(travel) {
    this.travelServ.deleteTravel(travel, this.description).then(res => {
      this.travels.forEach(tr => {
        if (tr.id == travel.id) {
          tr.status = "Cancelado";
        }
      });
      this.toastr.successToastr('Eliminado Correctamente');

      this.travelServ.getTravel(travel.id).then(tr => {
        this.logisticEv.sendTravelDeleted(tr);
      });
    });
  }

}
